import { useState, useEffect, useCallback, useRef } from "react";

import "../common/Util.css";
import Sidebar from "../common/Sidebar";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";

import Loader from "../common/loader";
import LoaderModal from "../common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";

import { format } from "date-fns";
import { getTripCostListApi, deleteTripsApi } from "../trip-cost/trip-cost-api";
import { useGlobal } from "../../GlobalContext";
import editIcon from "../../assets/svg/edit_ic.svg";
import deleteIcon from "../../assets/svg/delete_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";
import costIcon from "../../assets/svg/trip-list.svg";
import { Navbar } from "../common/Navbar";

export const TripsCostListing = () => {
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === "Trip cost" &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  // variable initial
  const isFirstRender = useRef(true);
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [productSelect, setProductSelect] = useState(null);
  const [vendorSelect, setVendorSelect] = useState(null);

  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tripCostListData, setTripCostListData] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);

  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ]);

  // handle
  const handleSelectProduct = (option) => {
    console.log("Selected option:", option);
    setProductSelect(option);
  };

  const [customerSelect, setCustomerSelect] = useState(null);
  const [locationSelect, setLocationSelect] = useState(null);
  const [costCategorySelect, setCostCategorySelect] = useState(null);

  const handleSelectCustomer = (option) => {
    console.log("Selected option:", option);
    setCustomerSelect(option);
  };
  const handleClearCustomer = () => {
    setCustomerSelect(null);
  };

  const handleSelectLocation = (option) => {
    setLocationSelect(option);
  };
  const handleClearLocation = () => {
    setLocationSelect(null);
  };

  const handleSelectCostCategory = (option) => {
    console.log("Selected option:", option);
    setCostCategorySelect(option);
  };

  const handleClearCostCategory = () => {
    setCostCategorySelect(null);
  };

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  // useEffect
  useEffect(() => {
    getCostList();
  }, [
    itemsPerPage,
    itemOffset,
    search,
    selectedSortby,
    costCategorySelect,
    customerSelect,
    locationSelect,
    startDateSave,
    endDateSave,
  ]);

  // Api
  const getCostList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "created",
      "desc",
    ];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      category: costCategorySelect?.value ?? "",
      customer_id: customerSelect?.value ?? "",
      location_id: locationSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getTripCostListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_count ?? 0);
        setPageCount(response.data.total_pages ?? 0);
        setTripCostListData(response.data.trip_cost ?? []);
      }
    } catch (err) {
      console.error("Error fetching cost data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const deleteCost = async () => {
    try {
      const response = await deleteTripsApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getCostList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error deleting cost:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"trip cost"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
        }}
        onDelete={deleteCost}
      />
      <div className="d-flex">
        <Sidebar currentfile="Trip Cost" />
        <div
          className="rounded-4 flex-grow-1"
          style={{ width: "calc(100vw - 80px)" }}
        >
          <Navbar pageTitle="Trip Cost" />
          <div
            className="bg-half-white p-2  scroll-hidden"
            style={{ height: "calc(100vh - 56px)" }}
          >
            {/* Cost Overview Cards */}
            {/* <div className="p-4">
              <div className="row mb-4">
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
                  >
                    <div className="fs-12 fw-400 text-gray mb-2">
                      Overall cost overview
                    </div>
                    <div className="fs-28 fw-700 textcolor">
                      ₹{(totalCost ?? 0).toLocaleString("en-IN")}
                    </div>
                    <div className="fs-12 fw-400 text-success mt-1">
                      5.28% from previous month
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
                  >
                    <div className="fs-12 fw-400 text-gray mb-2">Fuel cost</div>
                    <div className="fs-28 fw-700" style={{ color: "#3469E7" }}>
                      ₹45,000
                    </div>
                    <div className="fs-12 fw-400 text-secondary mt-1">
                      2.5 L 23.45%
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
                  >
                    <div className="fs-12 fw-400 text-gray mb-2">
                      Maintenance cost
                    </div>
                    <div className="fs-28 fw-700" style={{ color: "#F59E0B" }}>
                      ₹534
                    </div>
                    <div className="fs-12 fw-400 text-secondary mt-1">
                      1.31.45%
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
                  >
                    <div className="fs-12 fw-400 text-gray mb-2">
                      Total cost (this)
                    </div>
                    <div className="fs-28 fw-700" style={{ color: "#10B981" }}>
                      ₹45,000
                    </div>
                    <div className="fs-12 fw-400 text-secondary mt-1">
                      Cost data
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* Filters and Controls */}
            <div className="p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div
                  className="my-heading fs-21 fw-600"
                  style={{ color: "#9299A7" }}
                >
                  Trip & Cost : {totalCount}
                </div>

                <div className="d-flex flex-wrap gap-3">
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>

                  {checkPermission("create_permission") && (
                    <div
                      className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => navigate("/cost/create")}
                      style={{ height: "40px" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} />
                      </div>
                      <div
                        className="fs-12 fw-600"
                        style={{ lineHeight: "16px" }}
                      >
                        New Cost
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex flex-wrap justify-content-start gap-2">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          backgroundColor: "white",
                        }}
                        title={selectedSortby.label}
                      >
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {selectedSortby.label}
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedSortBy(option);
                            }}
                            active={selectedSortby === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}customer/autosuggestion`}
                      placeholder="Customer"
                      value={customerSelect}
                      onSelect={handleSelectCustomer}
                      handleClear={handleClearCustomer}
                    />
                  </div>

                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_locations`}
                      placeholder="Location"
                      value={locationSelect}
                      onSelect={handleSelectLocation}
                      handleClear={handleClearLocation}
                    />
                  </div>

                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}trips/cost-category`}
                      placeholder="Cost Category"
                      value={costCategorySelect}
                      onSelect={handleSelectCostCategory}
                      handleClear={handleClearCostCategory}
                    />
                  </div>

                  <div
                    className="d-flex align-items-center px-1"
                    style={{
                      borderRadius: "8px",
                      height: "32px",
                      border: "1px solid #EBEBEB",
                      backgroundColor: "white",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span className="dropdown-text1">
                      <DateRangePicker
                        onChange={handleDateChange}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </span>
                  </div>

                  <div
                    className="cursor-pointer ms-1 fs-12 fw-400 textGrey text-decoration-underline d-flex align-items-center justify-content-center"
                    style={{ height: "30px" }}
                    onClick={() => {
                      setCustomerSelect(null);
                      setLocationSelect(null);
                      setCostCategorySelect(null);
                      setStartDateSave(null);
                      setEndDateSave(null);
                      setStartDate(null);
                      setEndDate(null);
                    }}
                  >
                    Reset Filters
                  </div>
                </div>

                <div
                  className="rounded-3 toggleBg d-flex mt-2"
                  style={{
                    width: "80px",
                    height: "32px",
                    backgroundColor: "#FFFFFF",
                    padding: "4px",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #EBEBEB",
                  }}
                >
                  <div
                    onClick={() => setActive("list")}
                    className={`d-flex align-items-center justify-content-center rounded-3 ${
                      active === "list" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "list" ? (
                      <ListView style={iconStyle} />
                    ) : (
                      <SelectList style={iconStyle} />
                    )}
                  </div>

                  <div
                    onClick={() => setActive("grid")}
                    className={`d-flex align-items-center justify-content-center rounded-3 ${
                      active === "grid" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "grid" ? (
                      <SelectGrid style={iconStyle} />
                    ) : (
                      <EmailView style={iconStyle} />
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Table View */}
            {active === "list" && (
              <div className="w-100 trip-table-wrapper bg-white rounded-4 w-100">
                <div
                  style={{
                    display: "flex",
                    flex: "7",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    paddingTop: "16px",
                    height: "40px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #e5e5e5",
                  }}
                  className="head3 w-100 justify-content-start align-items-center"
                >
                  <p
                    style={{ flex: "1" }}
                    className="fs-13 fw-700 textcolor text-start table-header-p"
                  >
                    TRIP ID
                  </p>
                  <p
                    style={{ flex: "1" }}
                    className="fs-13 fw-700 textcolor text-start table-header-p"
                  >
                    FUEL COST
                  </p>
                  <p
                    style={{ flex: "1" }}
                    className="fs-13 fw-700 textcolor text-start table-header-p"
                  >
                    FASTAG COST
                  </p>
                  <p
                    style={{ flex: "1" }}
                    className="fs-13 fw-700 textcolor text-start table-header-p"
                  >
                    OTHER COST
                  </p>
                  <p
                    style={{ flex: "1" }}
                    className="fs-13 fw-700 textcolor text-start table-header-p"
                  >
                    TOTAL COST
                  </p>
                  <p
                    style={{ flex: "1" }}
                    className="fs-13 fw-700 textcolor text-start table-header-p"
                  >
                    DATE
                  </p>
                </div>
                <div>
                  {(tripCostListData ?? []).map((item, index) => (
                    <div
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        backgroundColor:
                          hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        borderLeft: "1px solid #D4DDE7",
                        borderRight: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                        position: "relative", // ⭐ REQUIRED FIX
                        overflow: "hidden", // prevent overlap
                      }}
                      onClick={() => {
                        if (checkPermission("view_permission")) {
                          navigate("/cost/view", {
                            state: { id: item.id },
                          });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.trip_id}
                      >
                        {item.trip_id ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={`₹${item.fuelcost}`}
                      >
                        ₹ {item.fuelcost ?? "0"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={`₹${item.fasttag_cost}`}
                      >
                        ₹ {item.fasttag_cost ?? "0"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.othercost}
                      >
                        ₹ {item.othercost ?? "0"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.totalcost}
                      >
                        ₹{item.totalcost ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.created_time}
                      >
                        {item.created_time ?? "---"}
                      </p>
                      {hoveredIndex === index && (
                        <div
                          style={{
                            position: "absolute",
                            right: "35px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            {checkPermission("edit_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/cost/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <img src={editIcon} alt="edit" />
                              </div>
                            )}
                            <span style={{ marginLeft: "16px" }}></span>
                            {checkPermission("delete_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <img src={deleteIcon} alt="delete" />
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Grid View */}
            {active === "grid" &&
              tripCostListData.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-4 d-flex flex-wrap align-items-center justify-content-between business-card w-100 p-3 mb-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("view_permission")) {
                      navigate("/cost/view", {
                        state: { id: item.id },
                      });
                    }
                  }}
                >
                  <div
                    className="col-12 col-md-6 col-lg-3 d-flex  pe-2"
                    style={{ borderRight: "1px solid #EBEBEB" }}
                  >
                    <div
                      className="profile-wrapper"
                      style={{ background: "#F4F4F4" }}
                    >
                      <img
                        key={index}
                        src={costIcon}
                        alt="cost"
                        className="profile-img"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-start gap-1 ps-3">
                      <div className="textFontColor fs-16 fw-600">
                        {item.trip_id ?? "-"}
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <span className="text-gray fs-12 fw-500">
                          {item.created_time ?? "---"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-md-6 col-lg-3 ps-3 d-flex flex-column align-items-start justify-content-start pe-1"
                    style={{ borderRight: "1px solid #EBEBEB" }}
                  >
                    <div className="d-flex flex-column flex-grow-1 align-items-start">
                      <div className="fs-12 fw-600 cardTextGrey">
                        FUEL COST :{" "}
                        <span className="fs-14 fw-400 textcolor">
                          ₹{item.fuelcost ?? "0"}
                        </span>
                      </div>
                      <div className="fs-12 fw-600 cardTextGrey mt-1">
                        FASTAG COST :{" "}
                        <span className="fs-14 fw-400 textcolor">
                          {item.fasttag_cost ?? ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-md-6 col-lg-4 ps-3 d-flex flex-column align-items-start justify-content-start pe-1"
                    style={{ borderRight: "1px solid #EBEBEB" }}
                  >
                    <div className="d-flex flex-column flex-grow-1 align-items-start">
                      <div className="fs-12 fw-600 cardTextGrey">
                        OTHER COST :{" "}
                        <span className="fs-14 fw-400 textcolor">
                          {item.othercost ?? ""}
                        </span>
                      </div>
                      <div className="fs-12 fw-600 cardTextGrey mt-1">
                        TOTAL COST :{" "}
                        <span className="fs-14 fw-400 textcolor">
                          {item.totalcost ?? ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-row align-items-end justify-content-end gap-2 ps-3">
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("edit_permission") ||
                        checkPermission("delete_permission")) && (
                        <Dropdown>
                          <Dropdown.Toggle
                            bsPrefix="custom-toggle"
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <img src={moreIcon} alt="more" />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #EBEBEB",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {checkPermission("edit_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/cost/create", {
                                    state: { id: item.id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission("delete_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(item.id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">
                  Records per page: &nbsp;
                </span>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="bg-transparent pagination-color border-0 custom-dropdown-toggle p-0"
                >
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="my-2"
                  style={{ minWidth: "unset", width: "30%" }}
                >
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
